module.exports = __webpack_public_path__ + "static/media/colosseum.fbd04808.jpg";